/**
 * Safely toggles a class on a given element by adding or removing it.
 *
 * @param {Element|null} element - The target DOM element.
 * @param {string} className - The class name to add or remove.
 * @param {boolean} shouldAdd - Whether to add (true) or remove (false) the class.
 */
function toggleClass(element, className, shouldAdd = false) {
  if (!element || typeof element !== "object" || typeof element.classList?.toggle !== "function") {
    console.warn("toggleClass: Invalid or unsupported element", element);
    return;
  }

  if (typeof className !== "string" || className.trim() === "") {
    console.warn("toggleClass: Invalid className provided", className);
    return;
  }

  try {
    element.classList.toggle(className, shouldAdd);
  } catch (error) {
    console.error(`toggleClass: Failed to toggle class '${className}'`, error);
  }
}

export default toggleClass;
